module.exports = __webpack_public_path__ + "img/boaviagem.788d6b35.svg";